/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 document.addEventListener('variant:changed', function(event) {
   var variant = event.detail.variant; // Gives you access to the whole variant details
   let container = document.getElementById('paypalteee');
   
   container.setAttribute('data-pp-amount',(Math.round(variant.price) / 100).toFixed(2));
 });

   
// Set "In stock" as the default option in the availability filter
//$("#filter-v-availability .collection__filter-checkbox:first-child .checkbox-wrapper input").prop("checked", true);

 let selectedSizeFormat = 'EU'; // Default to EU

 let lastSelectedSizeButton = null;


var removeactiveclass = function(activepiece) { 
  const activeElements = document.querySelectorAll(activepiece);

// Loop through the elements and remove the active class
for (const element of activeElements) {
  element.classList.remove("active");
}
}
var myFunction1 = function() {
  //alert("sdsds");
    const elements = document.getElementsByClassName('sizeoptoons');
for (var i = 0; i < elements.length; i++) {
    elements[i].classList.add("active");
}

  
    const elements2 = document.getElementsByClassName('fidex');
for (var i = 0; i < elements2.length; i++) {
    elements2[i].classList.add("active");
}
}
function myFunction(event,variable) {
   selectedSizeFormat = variable;
  lastSelectedSizeButton = event;
  removeactiveclass('.sizeclass');
  // this.element.classList.contains("")
  event.classList.add("active");
   // if(attribute.indexOf)
  if(variable=='EU')
  {
    
removeactiveclass('.sinfgle');
    const elements = document.getElementsByClassName('size-3');
for (var i = 0; i < elements.length; i++) {
    elements[i].classList.add("active");;
}

 
  }
  if(variable=='UK')
  {
    
removeactiveclass('.sinfgle');
    const elements = document.getElementsByClassName('size-1');
for (var i = 0; i < elements.length; i++) {
    elements[i].classList.add("active");;
}

 
  }
 if(variable=='US')
  {
    
removeactiveclass('.sinfgle');
    const elements = document.getElementsByClassName('size-2');
for (var i = 0; i < elements.length; i++) {
    elements[i].classList.add("active");;
}

 
  }
}



function selectVariant(imageElement) {
    // Example: Update variant information, price, etc.

    // Re-trigger the last selected size button click if it exists
    if (lastSelectedSizeButton) {
      lastSelectedSizeButton.click();
    }
  }

const elements1 = document.getElementsByClassName('selectfdf');


for (var i = 0; i < elements1.length; i++) {
    elements1[i].addEventListener('click', myFunction1, false);
}
   
                 

